import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../Buttons';
import Icon from '../Icon';

import {
  StyledBoxPerfil,
  StyledAvatar,
  StyledUser,
  StyledBoxAvatar,
  StyledName,
  StyledBoxinterior
} from './style';

import { Pencil } from '../../../../assets/images';

const Avatar = ({
  type,
  name,
  imgAvatar,
  perfil,
  className,
  editAvatar,
  showEditAvatar,
  avatarPhoto
}) => {
  const [timestamp, setTimestamp] = useState(null);
  useEffect(() => {
    setTimestamp(new Date().getTime());
  }, []);
  return (
    <StyledBoxPerfil className={className}>
      <StyledBoxinterior>
        {imgAvatar && <StyledAvatar svg={imgAvatar} />}
        <StyledBoxAvatar type={type}>
          {editAvatar && (
            <Button
              transparent
              className="avatar-edit"
              onClick={showEditAvatar}
            >
              <Icon dark size="m" svg={Pencil} />
            </Button>
          )}
          {avatarPhoto ? (
            <StyledUser src={`${perfil}?update=${timestamp}`} />
          ) : (
            <StyledName>{name}</StyledName>
          )}
        </StyledBoxAvatar>
      </StyledBoxinterior>
    </StyledBoxPerfil>
  );
};

Avatar.propTypes = {
  type: PropTypes.oneOf(['axis1', 'axis2', 'axis3']).isRequired,
  name: PropTypes.string,
  imgAvatar: PropTypes.shape({
    viewBox: PropTypes.string,
    url: PropTypes.string
  }),
  perfil: PropTypes.string,
  className: PropTypes.string,
  editAvatar: PropTypes.bool,
  showEditAvatar: PropTypes.func,
  avatarPhoto: PropTypes.bool
};

export default Avatar;
